<template>
	<main>
		<section class="eia-stage-six__step-wrapper">
			<header class="step-wrapper__header">
				<eia-heading level="h3">Step 1</eia-heading>
				<div>
					<eia-icon name="pencil"></eia-icon>
					<eia-link @click="modify( 0 )">Change</eia-link>
				</div>
			</header>

			<div class="step-wrapper__content">
				<eia-heading level="h5">Is your development a 'Schedule 1' development?</eia-heading>
				<span>{{ schedule1Development ? 'Yes' : 'No' }}</span>
			</div>
		</section>

		<section class="eia-stage-six__step-wrapper">
			<header class="step-wrapper__header">
				<eia-heading level="h3">Step 2</eia-heading>
				<div>
					<eia-icon name="pencil"></eia-icon>
					<eia-link @click="modify( 1 )">Change</eia-link>
				</div>
			</header>

			<div class="step-wrapper__content">
				<eia-heading level="h5">Proposal:</eia-heading>
				<span>{{ normalisedProposal }}</span>
			</div>
		</section>

		<section v-for="( q, i ) in questions"
			:key="q.id"
			class="eia-stage-six__step-wrapper">
			<header class="step-wrapper__header">
				<eia-heading level="h3">Step {{ 3 + i }}</eia-heading>
				<div>
					<eia-icon name="pencil"></eia-icon>
					<eia-link @click="modify( 2 + i )">Change</eia-link>
				</div>
			</header>

			<div v-if="( q.type === 'area-map' && manualAddressValid )"
				class="step-wrapper__content padded">
				<eia-heading level="h5">Address:</eia-heading>
				<span v-if="manualAddressValid"
					class="pre">{{ manualAddressString }}</span>
				<span v-else
					class="pre">{{ addressString }}</span>
			</div>

			<div v-if="( q.type === 'area-map' )"
				class="step-wrapper__content padded">
				<eia-heading level="h5">Site Area:</eia-heading>
				<span class="pre">{{ formattedSiteArea }}</span>
			</div>

			<div class="step-wrapper__content">
				<eia-heading level="h5"
					v-html="nl2br(q.question)"></eia-heading>
				<span>{{ q.answer }}</span>
			</div>

		</section>

		<section class="eia-stage-six__step-wrapper">
			<header class="step-wrapper__header">
				<eia-heading level="h3">Step {{ 3 + questions.length }}</eia-heading>
				<div>
					<eia-icon name="pencil"></eia-icon>
					<eia-link @click="modify( 2 + questions.length )">Change</eia-link>
				</div>
			</header>

			<div class="step-wrapper__content">
				<eia-heading level="h5">Your Personal Details:</eia-heading>
				<eia-paragraph>
					<strong>Name:</strong> {{ userDetails.name }}<br>
					<strong>Email:</strong> {{ userDetails.email }}<br>
					<template v-if="userDetails.companyName">
						<strong>Company Name:</strong> {{ userDetails.companyName }}
					</template>
				</eia-paragraph>
			</div>
		</section>

		<section class="eia-stage-six__step-wrapper">
			<header class="step-wrapper__header">
				<eia-heading level="h3">The boring but important stuff</eia-heading>
			</header>

			<div class="step-wrapper__content">
				<eia-heading level="h5">
					Before sending us your details, please read and tick to confirm consent
				</eia-heading>

				<div class="content__consent-wrapper">

					<eia-well v-for="( cb, key ) in checkboxes"
						:key="key">
						<eia-form-group :id="cb.id+'_group'"
							:onLabelClick="() => toggle( !consent[cb.id], cb.id )">
							<eia-checkbox
								type="checkbox"
								:id="cb.id"
								:name="cb.id"
								v-model="consent[cb.id]"
								@input="toggle"
							>
							</eia-checkbox>
							<template slot="label">
								{{ cb.copy1 }}
								<eia-link v-if="cb.linkUrl"
									@click="e => linkClick( e, cb.linkUrl )"
								>{{ cb.linkLabel }}</eia-link>
								{{ cb.copy2 }}
							</template>
						</eia-form-group>
					</eia-well>

				</div>
			</div>
		</section>
	</main>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { numberToDisplayFormat, nl2br } from '@/utils/string-utils';
import result from 'lodash.result';
import { to } from '@/utils/promise-utils';

export default {
	name: 'eia-review-details',

	data() {
		return {
			questions: [],
			checkboxes: [
				{
					id: 'privacyPolicy',
					copy1: 'I have read the Quod',
					linkUrl: '/#/privacy-policy',
					linkLabel: 'privacy policy',
					copy2: 'and consent to the processing of my personal data, subject to the terms of that policy.',
				},
				{
					id: 'termsOfUse',
					copy1: 'I have read and accept the',
					linkUrl: '/#/terms-of-use',
					linkLabel: 'terms of use',
					copy2: 'relating to the Quod EIA screening tool.',
				},
				{
					id: 'contact',
					copy1: 'I request and consent to Quod contacting me to discuss the result of my use of the EIA screening tool and to receive information from Quod on the EIA services they provide.',
				},
			],
		};
	},

	beforeMount(){

		// set up questions
		let questionId = 0;

		for( const r of this.responses ){

			for( const q of this.proposal.questions ){
				if( q.id === questionId ){

					this.questions.push( {
						question: q.question,
						answer: r.label,
						type: q.type,
					} );

					break;
				}
			}

			questionId = Number( r.result );

		}

		console.log( 'responses', this.responses );
		console.log( 'proposal.questions', this.proposal.questions );
		console.log( 'questions', this.questions );

		this.emit();

	},

	watch: {

		valid(){
			this.emit();
		},

	},

	computed: {

		...mapState( 'stages', [
			'schedule1Development',
			'proposal',
			'responses',
			'manualAddressValid',
			'consent',
		] ),

		...mapGetters( 'stages', [
			'manualAddressArray',
			'addressArray',
			'displaySiteAreaUnified',
			'siteAreaDisplayUnits',
			'userDetails',
			'getSubmissionPayload',
			'hasSiteArea',
			'totalStages',
		] ),

		stepOffset(){
			return ( this.hasSiteArea ? 1 : 0 ) + ( this.manualAddressValid ? 1 : 0 );
		},

		stepTotal(){
			return this.totalStages;
		},

		formattedSiteArea() {
			return `${numberToDisplayFormat( this.displaySiteAreaUnified )} ${this.siteAreaDisplayUnits.displayLongName}`;
		},

		manualAddressString() {
			return this.manualAddressArray.join( ',\n' );
		},

		addressString() {
			return this.addressArray.join( ',\n' );
		},

		normalisedProposal() {
			return result( this, 'proposal.description', this.proposal );
		},

		valid() {
			return !Object.values( this.consent ).includes( false );
		},

	},

	methods: {
		async getResults( next ) {

			this.$store.commit( 'setLoading' );

			const [ err ] = await to( this.$store.dispatch( 'stages/getResults' ) );

			this.$store.commit( 'clearLoading' );

			if( err ) {
				this.emit();

				return this.$toasted.global.errorPermanent( err );
			}

			// pass back to progress to final stage
			next( true );
		},

		modify( i ){
			this.$store.commit( 'stages/modifyStageIndex', i );

			window.scrollTo( {
				top: 0,
				left: 0,
				behavior: 'smooth',
			} );
		},

		nl2br( s ){
			return nl2br( s );
		},

		toggle( value, key ){

			const consent = { ...this.consent };

			consent[ key ] = value;

			this.$store.commit( 'stages/setConsent', consent );

		},

		emit(){
			this.$emit( 'input', this.valid ? next => this.getResults( next ) : null );
		},

		linkClick( e, href ){
			window.open( href , '_blank' );
			e.stopPropagation();
		},
	},
};
</script>

<style lang="scss" scoped>
main {
	margin: 32px 0;

	.eia-stage-six__step-wrapper {
		max-width: 600px;
		margin-bottom: 16px;
		padding: 16px 0 32px 0;

		&:not( :last-of-type ) {
			border-bottom: 1px solid $color-grey-medium;
		}

		.step-wrapper__header {
			display: grid;
			grid-template-columns: 75% 25%;

			.eia-icon {
				margin-right: 8px;
			}

			.eia-link {
				display: inline-block;
			}
		}

		.step-wrapper__content {

			&.padded {
				padding-bottom: 15px;
			}

			.eia-heading {
				color: $color-primary;
			}

			.eia-paragraph {
				font-size: $text-subheading;
				margin: 0;
			}

			.content__consent-wrapper {
				/* re-enable the block below to show checkboxes as 2x2 grid */
				/*display: grid;
				grid-template-columns: repeat( 2, minmax( auto, 50% ) );
				grid-gap: 16px;

				@media screen and (max-width: $screen-s) {
					grid-template-columns: 1fr;
					grid-gap: 16px;
				}*/

				> .eia-well {
					height: 100%;

					.eia-checkbox {
						margin-right: 8px;
					}
				}
			}
		}
	}
}
</style>
